import React from 'react';
import { type MenuItem, type LiliComboboxWithInputValueConstraint, SelectMenuItem } from './SelectMenuItem';

interface SelectMenuListProps<T extends LiliComboboxWithInputValueConstraint> {
  id: string;
  items: MenuItem<T>[];
  selectedValue: T;
  searchWord: string;
  onItemClick: (value: T) => void;
}
export const SelectMenuList = <T extends LiliComboboxWithInputValueConstraint>({
  id,
  items,
  selectedValue,
  searchWord,
  onItemClick,
}: SelectMenuListProps<T>) => (
  <div className='w-full flex flex-col gap-[8px] mt-[12px] max-h-[200px] overflow-scroll'>
    {items.map((item) => (
      <SelectMenuItem
        id={id}
        key={item.itemDescription || item.title}
        item={item}
        searchWord={searchWord}
        isSelected={item.value === selectedValue}
        onClick={onItemClick}
      />
    ))}
  </div>);
